import { Accordion } from "Components/accordion";
import { Navigation } from "Components/navigation";
import { HeroSlider } from "Components/heroSlider";
import { HoverCTA } from "Components/hoverCTA";
import { PreviewCard } from "Components/previewCard";
import { Modals } from "Components/modals";
import { FiftyFiftySlider } from "Components/fiftyFiftySlider";
import { ClientLogos } from "Components/clientLogos";
import { ScrollEffects } from "Components/scrollEffects";
import { Search } from "Components/search";
import { HotModuleReplacementPlugin } from "webpack";
import { Forms } from 'Components/forms';
import {generateVideoThumbnailViaUrl} from "@rajesh896/video-thumbnails-generator";

export namespace Global {
	let calculateScrollBarPostion = () => {
		let $el = $('<div style="width: 100%"></div>');
		$el.appendTo('body');
		let constrainedWidth = $el.width();

		$el.css('width', '100vw');
		let fullWidth = $el.width();
		let scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);

		document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
		$el.remove();
	};

	let setTouchOrNoTouch = () => {
		let isTouchDevice = () => {
			return window.matchMedia("(pointer: coarse)").matches
		}

		if(isTouchDevice()) {
			document.body.classList.add('touch');
			document.body.classList.remove('no-touch');
		} else {
			document.body.classList.remove('touch');
			document.body.classList.add('no-touch');
		}
	}

    let checkExternalLinks = () => {
        function isExternal(url) {
            var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
            if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
            if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
            return false;
        }

        var anchors = document.getElementsByTagName("a");
        for (var i=0; i<anchors.length; i++) {
            // Add target to anchor link
            if (isExternal(anchors[i].href)) {
            anchors[i].target = "_blank";
            }
        }
    }

    let getStockQuoteData = () => {

        let quoteContainers = document.querySelectorAll('.js-stock-quote-container');

        if (quoteContainers.length > 0){
            const url = 'https://ir.worthingtonenterprises.com/feed/StockQuote.svc/GetFullStockQuoteList?apiKey=BF185719B0464B3CB809D23926182246&exchange=XNYS&symbol=WOR&pageSize=1'

            var dateTimeOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                hour12: false,
                minute: '2-digit',
                second: '2-digit'
            };

            // Get the stock quote every 10 minutes.
            setInterval(function(){
                getStockQuote(dateTimeOptions)
            }, 600000);

            getStockQuote(dateTimeOptions);

            function getStockQuote(obj: { year:string, month: string, day: string, hour: string, hour12: boolean, minute: string, second: string} ) {
                var xhr = new XMLHttpRequest();
                xhr.onload = stockQuoteCallback;
                xhr.open('get', url);
                xhr.send();
            }

            function stockQuoteCallback(data) {
                // console.info('Processing new quote...')

                if(data && data.target && data.target.responseText) {
                    let responseText = data.target.responseText

                    if(data.target.status === 200) {
                        try {
                            let respObj = JSON.parse(responseText)

	                        console.log(respObj);
                            //debugger
                            if(respObj && Array.isArray(respObj.GetFullStockQuoteListResult) && respObj.GetFullStockQuoteListResult.length === 1) {

                                let stockQuote = respObj.GetFullStockQuoteListResult[0];

                                quoteContainers.forEach( (quoteContainer) => {

                                    let quoteChange = quoteContainer.querySelector('.js-stock-change');
                                    let quoteValue = quoteContainer.querySelector('.js-stock-quote');

                                    if (quoteValue){
                                        quoteValue.innerHTML = '$'+ stockQuote.TradePrice.toFixed(2);
                                    }

                                    if (quoteChange){
                                        quoteChange.innerHTML = stockQuote.Change;
                                    }

                                    if (stockQuote.Change >= 0){
                                        quoteContainer.classList.remove('text-red-light');
                                        quoteContainer.classList.add('text-green');
                                    } else {
                                        quoteContainer.classList.remove('text-green');
                                        quoteContainer.classList.add('text-red-light');
                                    }
                                })
                            }
                        }
                        catch(e) {
                            console.warn('[Stock quote] JSON format error.')
                        }
                    }
                    else {
                        console.warn('[Stock quote] Request failed. Status: ' + this.status)
                    }
                }
                else {
                    console.warn('[Stock quote] Response is invalid.')
                }
            }
        }
    }

	//this function creates images from mp4s to use in the slider. The image comes back large so we convert it to canvas and make data uri
	//then reassign back to the img src with a smaller intrinsic size so load times are less.
	let createThumbnailsForMP4Videos = () => {
		let heroSliders = document.querySelectorAll('.hero-slider__topmost-parent');

		if (!heroSliders.length) {
			return;
		}

		heroSliders.forEach((heroSlider) => {
			let videoEls = heroSlider.querySelectorAll('video');
			let videoThumbs = heroSlider.querySelectorAll('.js-video-thumbs');
			let videosArray = [];

			if (videoEls.length) {
				videoEls.forEach((videoEl, index) => {
					videosArray.push(videoEl);
				});
			}

			if (videoEls.length) {
				videoEls.forEach((videoEl, index) => {
					let sourceEl = videosArray[index].querySelector('source');
					let videoUrl = sourceEl.getAttribute('src');

					generateVideoThumbnailViaUrl(videoUrl, 1).then((imgSrc) => {
						const tempImg = new Image();

						// Set an event handler to execute when the image is loaded
						tempImg.onload = function () {
							// Set the desired width and height for the resized image
							const newWidth = 105; // Set to your desired width
							const newHeight = 80; // Set to your desired height

							// Create a temporary canvas element
							const canvas = document.createElement('canvas');
							const ctx = canvas.getContext('2d');

							// Set the canvas dimensions to the new width and height
							canvas.width = newWidth;
							canvas.height = newHeight;

							// Draw the image onto the canvas with the desired dimensions
							ctx.drawImage(tempImg, 0, 0, newWidth, newHeight);

							// Convert the canvas content back to an image (data URL)
							const resizedImageData = canvas.toDataURL('image/jpeg'); // You can change the format if needed

							// Set the resized image as the source for your original image element
							let coverImg = videoThumbs[index];
							coverImg.setAttribute('src', resizedImageData);
						};

						// Set the source of the temporary image element to the original image URL
						tempImg.src = imgSrc;
					}).catch((err) => {
						console.error(err);
					})
				});
			}
		});
	};

    let getCookie = (cname) => {
        let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
    }

	let setupCookieBanner = () => {
		let currentURL = window.location.href;

		if (currentURL.indexOf("/landing-page") !== -1) {
			return;
		}
		let getCookie = (name) => {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) return parts.pop().split(';').shift();
		};

		// Function to set the cookie
		let setCookie = (name, value, days) => {
			const expires = new Date();
			expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
			document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
		}


		let hideBanner = () => {
			const banner:HTMLElement = document.getElementById('cookieBanner');
			if (banner) {
				banner.style.opacity = String(0);
				banner.style.visibility = 'hidden';
				setTimeout(() => {
					banner.style.display = 'none';
				}, 500); // Wait for the animation to complete (0.5 seconds)
				setCookie('bannerClosed', 'true', 30); // Cookie expires in 30 days
			}
		}

		const banner:HTMLElement = document.getElementById('cookieBanner');
		if (!getCookie('bannerClosed') && banner) {
			banner.style.display = 'block';
			// Trigger a reflow to start the animation
			banner.offsetHeight;
			banner.style.visibility = "visible";
			setTimeout(() => {
				banner.style.opacity = String(1);
			}, 1000);
		}

		const closeBannerButton = document.getElementById('closeBanner');
		if (closeBannerButton) {
			closeBannerButton.addEventListener('click', hideBanner);
		}
	};

	let playPauseButtonsSetup = () => {
		let playPauseButtons = document.querySelectorAll('.js-play-pause-video');

		if(!playPauseButtons.length) {
			return;
		}

		playPauseButtons.forEach((button) => {
			let parentContainer = button.closest('.hero-image');
			let videoEl = parentContainer.querySelector('.hero-image__bg') as HTMLVideoElement;
			let videoTextEl = videoEl.querySelector('.sr-only');

			button.addEventListener('click', function(e) {
				if (videoEl.paused || videoEl.ended) {
					// If the video is paused or ended, play it
					videoEl.play();
					button.classList.remove('hero-image__play--paused');
					button.setAttribute('title', 'Pause Video');
					videoTextEl.innerHTML = "Pause Video";
				} else {
					// If the video is playing, pause it
					videoEl.pause();
					button.classList.add('hero-image__play--paused');
					button.setAttribute('title', 'Play Video');
					videoTextEl.innerHTML = "Play Video";
				}
				e.preventDefault();
			});
		});
	};

	let applyBodyClassWhenModalOpen = () => {
		function applyOrRemoveClassToBody(mutationsList, observer) {
			mutationsList.forEach(mutation => {
				mutation.addedNodes.forEach(node => {
					if (node.nodeType === 1 && node.classList.contains('ah-modal-overlay') && window.matchMedia('(max-width: 767px)').matches) {
						// Apply the class to the body element
						document.querySelector('html').classList.add('state-fixed');
					}
				});

				mutation.removedNodes.forEach(node => {
					if (node.nodeType === 1 && node.classList.contains('ah-modal-overlay') && window.matchMedia('(max-width: 767px)').matches) {
						// Remove the class from the body element
						document.querySelector('html').classList.remove('state-fixed');
					}
				});
			});
		}

		const observer = new MutationObserver(applyOrRemoveClassToBody);
		const observerOptions = {
			childList: true, // Listen for changes in the child nodes of the target
			subtree: true // Include changes in the entire subtree of the target
		};
		observer.observe(document.body, observerOptions);
	};

    let loadGTM = () => {

        let loadTracking = getCookie("sf-tracking-consent");

        // checking false so we load tracking if user ignores popup
        if (loadTracking != "false") {
            document.write("<script type='text/javascript'>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5KXB6G3D');</script>");
        }
    }

	export const init = () => {
		calculateScrollBarPostion();
		setTouchOrNoTouch();
        checkExternalLinks();
        getStockQuoteData();
		playPauseButtonsSetup();
        loadGTM();
		//setupCookieBanner();
		createThumbnailsForMP4Videos();
		applyBodyClassWhenModalOpen();
		Navigation.init();
		Accordion.init();
        HeroSlider.init();
        HoverCTA.init();
        PreviewCard.init();
		Modals.init();
		FiftyFiftySlider.init();
		ClientLogos.init();
		ScrollEffects.init();
		Search.init();
        Forms.init();
	}
}

Global.init();
